const UNIT_MS: Record<string, number> = { s: 1000, m: 60_000, h: 3_600_000 }
const REFRESH_REGEX = /^(\d+)([smh])$/
const DEFAULT_REFRESH_INTERVAL = '5m'
const DISABLED = '0s'

/** Normalizes a node's `refreshInterval` ('30s' / '5m' / '1h'); unset gets the default, anything invalid disables. */
export function resolveRefreshInterval(interval: string = DEFAULT_REFRESH_INTERVAL): string {
  const trimmed = interval.trim()
  return REFRESH_REGEX.test(trimmed) ? trimmed : DISABLED
}

/** Milliseconds for a resolved interval; 0 means no refresh. */
export function toRefreshMs(interval: string): number {
  const match = REFRESH_REGEX.exec(interval)
  return match ? Number(match[1]) * UNIT_MS[match[2]] : 0
}
